module.exports = __webpack_public_path__ + "img/圆柱形读卡器 (8).3e30bdf8.jpg";